import React from "react";
export const IconButtonThumbnail = () => <svg xmlns="http://www.w3.org/2000/svg" width="72" height="76" fill="none"><rect width="31" height="23" x="20.5" y="26.5" fill="#FFEEE5" stroke="#CC3D00" rx="5.5"/><path stroke="#CC3D00" stroke-linecap="round" d="M30.5 37.5h12M36.5 43.5v-12"/></svg>;
